import { motion, AnimatePresence } from "framer-motion";
import "../../App.css";

export default function Modal({
  isOpen,
  onClose,
  children,
  maxWidth,
  modalContentClass,
  padding,
  closeButton = true,
  zIndex,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={zIndex ? { zIndex } : undefined}
          >
            <motion.div
              className={`modal-content ${modalContentClass || ""}`}
              initial={{ scale: 0.5, y: 100, opacity: 0 }}
              animate={{
                scale: 1,
                y: 0,
                opacity: 1,
                transition: { type: "spring", stiffness: 300, damping: 30 },
              }}
              exit={{
                scale: 0.5,
                y: 100,
                opacity: 0,
                transition: { duration: 0.3 },
              }}
              style={{
                maxWidth: maxWidth || "500px",
                padding: padding || "default",
              }}
            >
              {closeButton && (
                <motion.button
                  className="modal-close"
                  whileHover={{ scale: 1.2, rotate: 90 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={onClose}
                >
                  ×
                </motion.button>
              )}
              {children}
            </motion.div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
